import React from 'react';
import { Link } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import LoadingGif from '../../../../static/images/loading.gif'
import AppVars from '../../../../AppVars';

const appVars = AppVars.getInstance()

class PasswordFormMFA extends React.Component {
    render() {
        return (
            <>
                <div className="justify-content-center line-box">
                    <div role="banner">
                        <Row className="">
                            <Link to={appVars.getAppHomeURL(this.props.style)}><Image className="corner-logo absolute" alt="Toyota" src={require('../../../../static/images/Toyota-Logo.svg').default} /></Link>
                        </Row>
                    </div>
                    <div
                        id="logonAlert"
                        data-testid="accountLockedError"
                        className={`${this.props.isAccountLocked === true ? "error-modal" : "none"}`}
                        role="alert"
                        aria-hidden={`${this.props.isAccountLocked === true ? "false" : "true"}`}
                    >
                        <div className="error-modal-text">
                            This account is locked for 15 minutes due to multiple failed attempts. Please try again later or click "Reset Password" to unlock your account. For further help please <Link to="https://www.toyota.com/support/contact-us"><u>contact us</u></Link>.
                        </div>
                        <span onClick={this.props.hideModalLocked} className="modal-close">&times;</span>
                    </div>
                    <div
                        id="logonAlert"
                        data-testid="temporaryLockedError"
                        className={`${this.props.isLoginValid === false ? "error-modal" : "none"}`}
                        role="alert"
                        aria-hidden={`${this.props.isLoginValid === false ? "false" : "true"}`}
                    >
                        <div className="error-modal-text">
                            Invalid password. After 5 failed attempts, your account will be locked for security reasons.
                        </div>
                        <span onClick={this.props.hideModalInvalid} className="modal-close">&times;</span>
                    </div>
                    <div row="main">
                        {/* This row serves a purpose despite not having text. */}
                        <Row className={`${this.props.isLoginValid === false || this.props.isAccountLocked === true ? "none" : "block"}`} style={{ "height": "40px" }}></Row>
                        <Row className="title__TO left" style={{ "fontSize": "28px" }}>
                            Enter Your Password
                        </Row>
                        <Row className="justify-content-center message__TO left">
                            Please enter password to view or edit your personal information.
                        </Row>
                        <Form id="logonFormPassword" noValidate validated={this.props.isFormValid} onSubmit={this.props.handleFormSubmit}>
                            <Form.Group id="logonPasswordGroup" className="relative">
                                <Form.Label className={`${this.props.floatLabel ? "absolute floating-label" : "absolute inline-label"}
                                        ${this.props.onFocus === true ? "label-black__TO" : ""}
                                        ${this.props.isPasswordValid === false && this.props.onFocus === false ? "label-red__TO" : ""}`}>
                                    Password<span id="redStar">*</span>
                                </Form.Label>
                                <div className="absolute show-password">
                                    <img onClick={this.props.showHidePassword} src={this.props.showPassword ? require('../../../../static/images/TO/password-hide.svg').default : require('../../../../static/images/TO/password-show.svg').default} alt="showHide"></img>
                                    <span className='show-hide'>{this.props.showPassword ? 'Hide' : 'Show'}</span>
                                </div>
                                <Form.Control
                                    required
                                    id="logonPassword__TO"
                                    data-testid="logonPassword"
                                    aria-label="Password"
                                    as="input"
                                    type={`${this.props.showPassword === false ? "password" : "text"}`}
                                    name="password"
                                    placeholder=""
                                    value={this.props.password}
                                    onChange={this.props.handlePasswordChange}
                                    onFocus={this.props.setFocus}
                                    onBlur={this.props.onBlur}
                                    bsPrefix={`${this.props.isPasswordValid === false ? "highlight-error__TO form-control" : ""}`}
                                />
                                <div
                                    id="passwordAlert"
                                    data-testid="logonPasswordError"
                                    className={`logon-item-error__TO ${this.props.isPasswordValid === false && this.props.onFocus === false ? "block" : "none"}`}
                                    role="alert"
                                    aria-hidden={`${this.props.isPasswordValid === false && this.props.onFocus ? "false" : "true"}`}
                                >
                                    Please enter a password
                                </div>
                            </Form.Group>
                            <div className="required required-left-grid">
                                <span id="redStar">*</span>Required
                            </div>
                            <div className="button-right-cp">
                                <Button data-testid="logonButton" bsPrefix={`${(this.props.isPasswordValid !== true || this.props.isAccountLocked === true) ? "TO__button-disabled" : "TO__button "} `} type={this.props.isPasswordValid && "submit"} >Next Step</Button>
                                {this.props.isAccountLocked && <Button data-testid="passwordResetButton" bsPrefix="TO__button" onClick={this.props.handleResetPassword} style={{ margin: "10px", padding: "0" }}>Reset Password</Button>}
                            </div>
                            <Image data-testid="loadingGIF" className={`working ${this.props.loading ? "" : "none"}`} id="loadingGIF" src={LoadingGif} aria-hidden="true" />
                        </Form>
                    </div>
                </div>
                <div className="code-bottom" role="complementary">
                    <div className="code-bottom-title">
                        <div className="sign-in">Still having trouble?</div>
                        <div className='flex'>
                            <Link className="bottom-link-login bottom-link bottom-link-right" to={appVars.getSupportURL()} style={{ "marginLeft": "0px" }}>Support<img src={require('../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px" /></Link>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default PasswordFormMFA;